import instance from '../../../api/axios'

export const removeParticipant = async (id: string): Promise<any> => {
  const response = await instance.delete(`/wedding/participants/${id}`)
  return response.data
}
